import { render, staticRenderFns } from "./Keywords.vue?vue&type=template&id=6098765c&scoped=true"
import script from "./Keywords.vue?vue&type=script&lang=js"
export * from "./Keywords.vue?vue&type=script&lang=js"
import style0 from "./Keywords.vue?vue&type=style&index=0&id=6098765c&prod&lang=scss&scoped=true"
import style1 from "./Keywords.vue?vue&type=style&index=1&id=6098765c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6098765c",
  null
  
)

export default component.exports